module.exports = {"532302101":"金山镇","532302102":"仁兴镇","532302103":"碧城镇","532302104":"勤丰镇","532302105":"一平浪镇","532302106":"广通镇","532302107":"黑井镇","532302108":"土官镇","532302109":"彩云镇","532302110":"和平镇","532302111":"恐龙山镇","532302201":"中村乡","532302202":"高峰乡","532302203":"妥安乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532302.json
// module id = 2750
// module chunks = 0